import Form from 'react-bootstrap/Form'
import { Col, Row } from 'react-bootstrap'
import dayjs from 'dayjs'
import { Controller } from 'react-hook-form'
import InputDomicilioValidado from '../components/InputDomicilioIntegranteOrgano'
import React from 'react'

const DatosContribuyenteOrgano = (props) => {
  const {
    register,
    errors,
    trigger,
    getValues,
    setValue,
    control,
    watch
  } = props.methods
  const { fields, remove, agregarIntegrante, patronCorreoElectronico } = props

  const quitarIntegrante = (evento, index) => {
    evento.preventDefault()
    remove(index)
  }

  const validarDesdeMenorHasta = (i) => {
    const cargoVigente = watch(`integrante[${i}].cargoVigente`)
    const desde = watch(`integrante[${i}].desde`)
    const hasta = watch(`integrante[${i}].hasta`)

    if (cargoVigente) {
      return true
    } else if (!hasta) {
      return false
    } else if (!desde) {
      return true
    }

    const inicio = dayjs(desde, 'YYYY-MM-DD')
    const fin = dayjs(hasta, 'YYYY-MM-DD')
    return inicio.isBefore(fin)
  }

  const habilitarBotonAgregarIntegrante = watch('integrante').length < 3

  const renderBotonQuitarIntegrante = (indice) => {
    return (
      <button
        onClick={(e) => {
          quitarIntegrante(e, indice)
        }}
        className={'btn btn-link'}
      >
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          className="bi bi-trash"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
          <path
            fillRule="evenodd"
            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
          />
        </svg>
      </button>
    )
  }

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase">
        Integrantes de Órgano Directivo
      </h6>
      <hr className="margin-bottom-1x" />

      {fields.map((integrante, i) => {
        const deshabilitarFechaHasta = watch(`integrante[${i}].cargoVigente`)
        const elementoValido = (nombre, indice) =>
          !errors?.['integrante']?.[indice]?.[nombre] &&
          getValues(`integrante[${indice}].${nombre}`)
        const elementoInvalido = (nombre, indice) =>
          errors?.['integrante']?.[indice]?.[nombre]

        const datosValidacion = (nombre) => {
          return {
            name: `integrante[${i}].${nombre}`,
            isValid: elementoValido(nombre, i),
            isInvalid: elementoInvalido(nombre, i)
          }
        }

        return (
          <div key={integrante.id}>
            <div className="margin-bottom-1x" style={{ paddingLeft: '15px' }}>
              <span>
                <b>Integrante {i + 1}</b>
              </span>
              <span>{i > 0 && renderBotonQuitarIntegrante(i)}</span>
            </div>
            <Form.Row>
              <Col>
                <Form.Group controlId="formApellidoNombre">
                  <Form.Label>Apellido y Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Apellido y Nombre"
                    ref={register({ required: true })}
                    {...datosValidacion('nombre')}
                  />
                  <Form.Control.Feedback type="invalid">
                    Debe completar el campo
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="formCuitDNI">
                  <Form.Label>Ingrese Cuil / DNI</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese CUIL o DNI"
                    {...datosValidacion('cuil')}
                    ref={register({ pattern: /^[\d]{11}$/, required: true })}
                  />
                  <Form.Control.Feedback type="invalid">
                    El CUIL consiste de 11 dígitos numéricos
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col>
                <Form.Group controlId="formCargo">
                  <Form.Label>Cargo</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese Cargo"
                    ref={register({ required: true })}
                    {...datosValidacion('cargo')}
                  />
                  <Form.Control.Feedback type="invalid">
                    Debe ingresar el cargo
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Row>
                  <Col>
                    <Form.Group controlId="formFechaDesde">
                      <Form.Label>Desde</Form.Label>
                      <Form.Control
                        type="date"
                        placeholder="Ingrese Fecha de Inicio"
                        {...datosValidacion('desde')}
                        ref={register({
                          required: true,
                          validate: async (val) => {
                            const hoyFecha = dayjs()
                            const desdeFecha = dayjs(val, 'YYYY-MM-DD')

                            if (watch(`integrante[${i}].hasta`)) {
                              trigger(`integrante[${i}].hasta`)
                            }

                            return (
                              desdeFecha.isBefore(hoyFecha) ||
                              desdeFecha.isSame(hoyFecha, 'day') ||
                              'La fecha de inicio no puede ser posterior al día de hoy'
                            )
                          }
                        })}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.['integrante']?.[i]?.['desde']?.message ||
                          'Debe ingresar la fecha de inicio'}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="formFechaHasta">
                      <Form.Label>Hasta</Form.Label>
                      <Form.Control
                        type="date"
                        placeholder="Ingrese Fecha de Fin"
                        ref={register({
                          validate: async () => {
                            return new Promise(function (resolve, reject) {
                              setTimeout(function () {
                                resolve(validarDesdeMenorHasta(i))
                              })
                            })
                          }
                        })}
                        disabled={deshabilitarFechaHasta}
                        {...datosValidacion('hasta')}
                      />
                      <Form.Control.Feedback type="invalid">
                        Debe ingresar la fecha hasta o seleccionar cargo vigente
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="formCargoVigente">
                      <Form.Label></Form.Label>
                      <Controller
                        control={control}
                        name={`integrante[${i}].cargoVigente`}
                        defaultValue={false}
                        render={({ onChange, onBlur, value, name, ref }) => (
                          <Form.Check
                            label={'Cargo Vigente'}
                            checked={!!value}
                            name={`integrante[${i}].cargoVigenteCheck`}
                            onBlur={onBlur}
                            onChange={(e) => {
                              onChange(e.target.checked)
                              if (e.target.checked) {
                                setValue(`integrante[${i}].hasta`, '')
                              }
                              trigger(`integrante[${i}].hasta`)
                            }}
                            ref={register({ required: false })}
                          />
                        )}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col>
                <InputDomicilioValidado
                  errors={errors}
                  register={register}
                  controlId={'organo' + i}
                  indice={i}
                  elementoValido={elementoValido}
                  elementoInvalido={elementoInvalido}
                />
              </Col>
            </Form.Row>
            <Form.Row>
              <Col md={6}>
                <Form.Group controlId="formLocalidadOrgano">
                  <Form.Label>Localidad</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese la localidad de residencia"
                    {...datosValidacion('localidad')}
                    ref={register({
                      required: true
                    })}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formEmailOrgano">
                  <Form.Label>EMAIL</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Ingrese un E-mail válido"
                    {...datosValidacion('correoElectronico')}
                    ref={register({
                      pattern: patronCorreoElectronico,
                      required: true
                    })}
                  />
                </Form.Group>
              </Col>
            </Form.Row>
          </div>
        )
      })}
      <div>
        <button
          disabled={!habilitarBotonAgregarIntegrante}
          onClick={(e) => {
            e.preventDefault()
            agregarIntegrante()
          }}
          className={'btn btn-primary btn-sm'}
        >
          Agregar Integrante
        </button>
      </div>
      <hr className="margin-bottom-1x margin-top-1x" />
    </>
  )
}

export default DatosContribuyenteOrgano
